import { ValueGetterParams } from "ag-grid-community";
import { BudgetWithIntegrations } from "@/store/budgets/utils/types/common";

export const budgetScopeFilterValueGetter = ({
  data,
}: ValueGetterParams<BudgetWithIntegrations>) => {
  if (data?.view?.name) {
    return data?.view?.name;
  }

  return data?.filter_tree ? "Filters" : undefined;
};
